<template>
  <div class="teacher" @mouseover="enter" @mouseleave="leave">
    <swiper :options="swiperOptions" ref="teacherSwiper">
      <swiper-slide v-for="item in teacherList" :key="item.TeacherId">
        <div class="box">
          <div class="left">
            <img :src="item.TeacherImgs">
          </div>
          <div class="right">
            <div class="info">
              <h5>{{item.TeacherName}}</h5>
              <span :title="item.CourseName">{{item.CourseName}}</span>
              <p :title="item.Introduction" v-html="item.Introduction"></p>
            </div>
            <div class="evaluation">
              <div class="level item">
                <img src="https://img2.233.com/wx/union/pure/pc/teacher_ic_1.png">
                <div class="cell">
                  <p>教学水平({{item.JXScore}})</p>
                  <div class="schedule">
                    <span :style="{'width': item.JXScore}"></span>
                  </div>
                </div>
              </div>
              <div class="quality item">
                <img src="https://img2.233.com/wx/union/pure/pc/teacher_ic_2.png">
                <div class="cell">
                  <p>上课内容({{item.SKScore}})</p>
                  <div class="schedule" :style="{'width': item.SKScore}">
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" v-if="teacherList.length > 1"></div>
      <div class="swiper-button-next" slot="button-next" v-if="teacherList.length > 1"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: "Teacher",
  props: {
    teacherList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiperOptions: {
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        autoplay: 3000,
        autoplayDisableOnInteraction : false,
      }
    }
  },
  mounted() {
    if (this.teacherList.length < 2) {
        this.$refs.teacherSwiper.swiper.stopAutoplay()
    }
  },
  methods: {
    enter() {
      this.$refs.teacherSwiper.swiper.stopAutoplay()
    },
    leave() {
      this.$refs.teacherSwiper.swiper.startAutoplay()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.teacher{
  width: 611px;
  height: 100%;
  background: #fff;
  .box{
    display: flex;
    justify-content: space-between;
    padding: 27px 0 27px 24px;
    .left{
      img{
        width: 280px;
        height: 350px;
      }
    }
    .right{
      width: 283px;
      position: relative;
      &::before{
        content: "";
        position: absolute;
        top: -27px;
        left: 0;
        width: 40px;
        height: 2px;
        @include recommend_teacher_background();
      }
      .info{
        width: 205px;
        height: 288px;
        overflow-y: hidden;
        h5{
          font-size: 24px;
          color: #343434;
          font-size: bold;
          line-height: 38px;
        }
        span{
          font-size: 16px;
          color: #343434;
          font-weight: 400;
          line-height: 24px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          display: inline-block;
          width: 100%;
        }
        p{
          margin-top: 23px;
          font-size: 14px;
          color: #888;
          font-weight: 400;
          line-height: 20px;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 9;
          -webkit-box-orient: vertical;
        }
      }
      .evaluation{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-top: 28px;
        border-top: 1px solid #ECECEC;
        display: flex;
        .item{
          display: flex;
          img{
            width: 25px;
            height: 25px;
            margin-right: 7px;
          }
          .cell{
            p{
              font-size: 12px;
              color: #565656;
              font-weight: 400;
            }
            .schedule{
              margin-top: 3px;
              width: 97px;
              height: 5px;
              background: #ECECEC;
              border-radius: 3px;
              position: relative;
              span{
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                width: 92%;
                height: 5px;
                @include recommend_teacher_step_background();
                border-radius: 3px;
              }
            }
          }
        }
        .level{
          margin-right: 20px;
        }
      }
    }
  }
  .swiper-button-prev{
    background: url(https://img2.233.com/wx/union/pure/pc/btn_left.png) no-repeat;
    background-size: 100% 100%;
    width: 72px;
    height: 144px;
    margin-top: -72px;
    left: 0;
    &::after{
      content: "";
    }
    &:hover{
      background: url(https://img2.233.com/wx/union/pure/pc/btn_left_hover.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .swiper-button-next{
    background: url(https://img2.233.com/wx/union/pure/pc/btn_right.png) no-repeat;
    background-size: 100% 100%;
    width: 72px;
    height: 144px;
    margin-top: -72px;
    right: 0;
    &::after{
      content: "";
    }
    &:hover{
      background: url(https://img2.233.com/wx/union/pure/pc/btn_right_hover.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>